/* ============================================================
   BNZ Précommande — logique partagée
   1. Countdowns (bandeau sticky + bloc compte à rebours)
   2. Compteur de rareté (stock réel + repli manuel + preuve sociale)
   3. Classe body.preorder-bar-active
   Idempotent : ne s'initialise qu'une fois même si chargé 2x.
   ============================================================ */
(function () {
  if (window.__bnzPreorderInit) return;
  window.__bnzPreorderInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    /* -------- body.preorder-bar-active -------- */
    if (document.querySelector('.bnz-preorder-bar')) {
      document.body.classList.add('preorder-bar-active');
    }

    /* ============================================================
       1. COUNTDOWNS
       Sélecteurs : bandeau (.bnz-preorder-bar) + bloc (.bnz-po-countdown).
       Contrairement à bnz-timer-bar.js, on NE supprime PAS le noeud à
       expiration (les blocs in-section doivent rester) : on bascule en
       état "is-expired".
       ============================================================ */
    var countdownRoots = document.querySelectorAll(
      '.bnz-preorder-bar[data-timer-date], .bnz-po-countdown[data-timer-date]'
    );

    countdownRoots.forEach(function (root) {
      var target = new Date(root.getAttribute('data-timer-date')).getTime();
      if (isNaN(target)) return;

      var dEl = root.querySelector('[data-days]');
      var hEl = root.querySelector('[data-hours]');
      var mEl = root.querySelector('[data-minutes]');
      var sEl = root.querySelector('[data-seconds]');

      function pad(n) {
        return n.toString().padStart(2, '0');
      }

      function tick() {
        var distance = target - new Date().getTime();

        if (distance <= 0) {
          if (root._countdownInterval) clearInterval(root._countdownInterval);
          if (dEl) dEl.textContent = '00';
          if (hEl) hEl.textContent = '00';
          if (mEl) mEl.textContent = '00';
          if (sEl) sEl.textContent = '00';
          root.classList.add('is-expired');
          return;
        }

        var days = Math.floor(distance / 86400000);
        var hours = Math.floor((distance % 86400000) / 3600000);
        var minutes = Math.floor((distance % 3600000) / 60000);
        var seconds = Math.floor((distance % 60000) / 1000);

        if (dEl) dEl.textContent = pad(days);
        if (hEl) hEl.textContent = pad(hours);
        if (mEl) mEl.textContent = pad(minutes);
        if (sEl) sEl.textContent = pad(seconds);
      }

      tick();
      root._countdownInterval = setInterval(tick, 1000);
    });

    /* ============================================================
       2. COMPTEUR DE RARETÉ
       reserved = total - stock(variante) si l'inventaire est suivi,
       sinon repli sur reserved_override.
       ============================================================ */
    var scarcityRoots = document.querySelectorAll('.bnz-po-scarcity');

    // PRNG seedé (mulberry32) — preuve sociale stable par pageview, dérive chaque heure
    function seededRand(seed) {
      var t = (seed += 0x6d2b79f5);
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    }

    function intInRange(rand, min, max) {
      if (max < min) max = min;
      return Math.floor(min + rand * (max - min + 1));
    }

    function getSelectedVariantId(data) {
      var sel = document.getElementById('variant-selected');
      if (sel && sel.value) return parseInt(sel.value, 10);
      var vid = document.getElementById('variant-id');
      if (vid && vid.value) return parseInt(vid.value, 10);
      var first = Object.keys(data)[0];
      return first ? parseInt(first, 10) : null;
    }

    function applyTokens(tpl, map) {
      var out = tpl || '';
      Object.keys(map).forEach(function (k) {
        out = out.split('{' + k + '}').join(map[k]);
      });
      return out;
    }

    scarcityRoots.forEach(function (root) {
      var total = parseInt(root.getAttribute('data-series-total'), 10) || 1000;
      var override = parseInt(root.getAttribute('data-reserved-override'), 10) || 0;
      var labelTpl = root.getAttribute('data-label-tpl') || '{reserved} / {total} unités réservées · {remaining} restantes';
      var socialTpl = root.getAttribute('data-social-tpl') || '';
      var wMin = parseInt(root.getAttribute('data-watching-min'), 10);
      var wMax = parseInt(root.getAttribute('data-watching-max'), 10);
      var rhMin = parseInt(root.getAttribute('data-reserved-hour-min'), 10);
      var rhMax = parseInt(root.getAttribute('data-reserved-hour-max'), 10);

      var fillEl = root.querySelector('.bnz-po-scarcity__fill');
      var labelEl = root.querySelector('.bnz-po-scarcity__label');
      var barEl = root.querySelector('.bnz-po-scarcity__bar');
      var socialEl = root.querySelector('.bnz-po-scarcity__social');

      function computeReserved() {
        var data = window.__bnzGaugeData || {};
        var id = getSelectedVariantId(data);
        var v = id ? data[id] : null;

        // Repli manuel : override prioritaire, ou données stock absentes / non suivies / invalides
        if (override > 0) return Math.max(0, Math.min(total, override));
        if (!v || v.t !== true || typeof v.q !== 'number') {
          return Math.max(0, Math.min(total, override));
        }
        var reserved = total - v.q;
        return Math.max(0, Math.min(total, reserved));
      }

      function render() {
        var reserved = computeReserved();
        var remaining = total - reserved;
        // La barre représente le stock RESTANT : elle se vide à mesure que les réservations augmentent.
        var pct = total > 0 ? (remaining / total) * 100 : 0;
        pct = Math.max(0, Math.min(100, pct));
        if (remaining > 0 && pct < 3) pct = 3; // garde un mince filet visible tant qu'il reste du stock

        if (fillEl) fillEl.style.width = pct + '%';
        if (labelEl) {
          labelEl.textContent = applyTokens(labelTpl, {
            reserved: reserved,
            total: total,
            remaining: remaining
          });
        }
        if (barEl) {
          barEl.setAttribute('role', 'progressbar');
          barEl.setAttribute('aria-valuenow', String(remaining));
          barEl.setAttribute('aria-valuemin', '0');
          barEl.setAttribute('aria-valuemax', String(total));
        }
      }

      // Preuve sociale — calculée une fois (stable par pageview / heure)
      if (socialEl && socialTpl && !isNaN(wMin) && !isNaN(wMax) && !isNaN(rhMin) && !isNaN(rhMax)) {
        var hourSeed = Math.floor(Date.now() / 3600000);
        var watching = intInRange(seededRand(hourSeed), wMin, wMax);
        var reservedHour = intInRange(seededRand(hourSeed + 7919), rhMin, rhMax);
        socialEl.innerHTML = applyTokens(socialTpl, {
          watching: '<strong>' + watching + '</strong>',
          reserved_hour: '<strong>' + reservedHour + '</strong>'
        });
      }

      render();

      // Re-render au changement de variante (réutilise le hub stock_gauge si présent)
      window.__bnzStockGaugeRenders = window.__bnzStockGaugeRenders || [];
      window.__bnzStockGaugeRenders.push(render);

      // N'attache un listener que si stock_gauge n'a pas déjà le sien
      // (il itère le même tableau __bnzStockGaugeRenders).
      if (!window.__bnzPoScarcityBound && !window.__bnzStockGaugeListener) {
        window.__bnzPoScarcityBound = true;
        document.addEventListener('change', function (e) {
          if (e.target && e.target.closest && e.target.closest('.product-variant')) {
            setTimeout(function () {
              (window.__bnzStockGaugeRenders || []).forEach(function (fn) {
                try { fn(); } catch (err) {}
              });
            }, 0);
          }
        });
      }
    });

    /* -------- Nettoyage -------- */
    window.addEventListener('beforeunload', function () {
      countdownRoots.forEach(function (root) {
        if (root._countdownInterval) clearInterval(root._countdownInterval);
      });
    });
  });
})();
